import {
    isArray,
    isObject
} from "./main";
import {
    deepClone
} from "./obj";

String.prototype.has = function(subStr) {return !!~this.indexOf(subStr);};

// фильтрация по спецификации TableApi v2.0
// filters: {
//    KEY: {
//       not: true/false
//       search: "like str" / undefined
//       values: [ 1, 2, 3 ]  /  [ {start: "ISO DATE", end: "ISO DATE"} ],
//       withNulls: true / false
//    }
//    %AND%
//    ....
// }
// операция с одной строкой
export function filterRow(row, filters) {

    let value; let params; let isLiked; let inValues;


    let keysLength;
    let not;

    for (let key in filters) {
        value = row[key];
        params = filters[key];

        isLiked = true;
        inValues = true;
        keysLength = Object.keys(params).length;

        // если на входе пустой объект, игнорируем его
        if ( keysLength === 0 ) {
            continue;
        }

        if ( params.noRows ) {
            return false;
        }

        // поиск только пустых
        if ( keysLength === 1 && params.withNulls === true ) {
            return value === "";
        }

        // отсекаем пустые строки если надо
        if ( params.withNulls === false && value == null ) {
            if ( !params.not ) {
                return false;
            }
        }

        // аналог sql: like '%search%'
        if ( params.search ) {
            isLiked = likeStr(value + "", params.search);
        }

        // аналог sql: value in (1, 2, 3)
        if ( isArray(params.values) && params.values.length > 0 ) {
            inValues = params.values.indexOf(value) != -1;
        }

        not = !!params.not;
        if ( not == ( isLiked && inValues ) ) {
            return false;
        }
    }

    return true;
}

// операция с массивом
export function filter(arr, filters) {
    // indexOf делает строгое сравнение
    // преобразуем фильтры .values в строки
    filters = deepClone(filters);
    for (let key in filters) {
        if ( isArray(filters[key].values) ) {
            filters[key].values = filters[key].values.map(function(value) {
                return value + "";
            });
        }
    }

    return arr.filter(function(row) {
        return filterRow(row, filters);
    });
}

export function likeStr(str, search) {
    return str.toLowerCase().indexOf(search.toLowerCase()) != -1;
}

export function searchByLikeStr(arr, keys, str) {
    let value;
    let outRows = [];
    let hasStr;

    for (let i = 0, n = arr.length; i < n; i++) {
        hasStr = false;
        for (let j = 0, m = keys.length; j < m; j++) {
            value = arr[i][keys[j]];
            if ( likeStr(value, str) ) {
                hasStr = true;
                break;
            }
        }

        if ( !hasStr ) {
            continue;
        }

        outRows.push(arr[i]);
    }

    return outRows;
}

// фильтр с пустыми данными или эквивалетный пустым фильтрам
export function isClearFilter(filter) {
    if ( !isObject(filter) ) {
        return true;
    }

    let keysLength = Object.keys(filter).length;

    if ( !isObject(filter) || keysLength === 0 ) {
        return true;
    }

    if ( keysLength == 1 ) {
        if ( filter.values == "all" ) {
            return true;
        }
        if ( filter.withNulls ) {
            return true;
        }
    }
    else if ( keysLength == 2 ) {
        if ( filter.values == "all" && filter.withNulls ) {
            return true;
        }
    }

    return false;
}

// преобразуем старый формат фильтров в новый
export function oldFilters2newFilters(old) {
    let newFilter = {};


    let cond;


    let newCond;

    for (let key in old) {
        cond = old[key];

        if ( cond.search && cond.values || cond.not ) {
            newCond = {
                key,
                type: "composite",
                search: cond.search
            };

            if ( cond.not ) {
                newCond.notValues = cond.values;
            } else {
                newCond.values = cond.values;
            }
        }
        else if ( cond.search ) {
            newCond = {
                key,
                type: "contain",
                value: cond.search,
                not: !!cond.not
            };
        }
        else if ( cond.values ) {
            newCond = {
                key,
                type: "in",
                value: cond.values
            };
        } else {
            newCond = {};
        }

        if ( "withNulls" in cond ) {
            newCond.withNulls = cond.withNulls;
        }


        newFilter[key] = newCond;
    }

    return newFilter;
}

// 17.07.2016 - используется только во вкладках,
// более точную проверку делать не смысла
export function isOldFilter(something) {
    if ( !isObject(something) ) {
        return false;
    }

    if ( isArray(something.query) && isObject(something.conditions) ) {
        return false;
    }

    return true;
}
